var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    fillRule: "evenodd",
    height: "1em",
    style: {
      flex: "none",
      lineHeight: 1
    },
    viewBox: "0 0 24 24",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Colab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.146 6.406l.103.079-1.727 2.959a3.637 3.637 0 00-5.098 0 3.648 3.648 0 00-1.046 2.34l-.006.222c0 .959.379 1.88 1.054 2.56l-.013.014a3.637 3.637 0 005.11-.014l1.764 2.954-.117.084a6.989 6.989 0 01-9.127-.654A7.003 7.003 0 010 12.008a6.975 6.975 0 016.16-6.933l.312-.03a6.988 6.988 0 014.674 1.361zM16.916 5a6.99 6.99 0 014.935 2.063l-.015.018.194.211a6.988 6.988 0 011.73 4.38l.004.305a6.988 6.988 0 01-11.819 4.973 7.002 7.002 0 01-2.043-4.942c0-1.852.736-3.629 2.045-4.94v-.016l.021-.02A6.987 6.987 0 0116.916 5zm.305 3.662L17 8.668a3.637 3.637 0 00-2.627 5.899 3.637 3.637 0 005.096-5.123 3.628 3.628 0 00-2.026-.775l-.22-.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColabLogo);
export default __webpack_public_path__ + "static/media/colab_logo.f39461ae352b8de760abc7c0d6facfb2.svg";
export { ForwardRef as ReactComponent };